import Vue from 'vue';
import Vuex from 'vuex';
//root级mutations
import mutations from './mutations'
//root级actions
import actions from './actions'
//root级getters
import getters from './getters'

Vue.use(Vuex);

const state = {//公共变量
    userInfo: {},
    isLogin: false,
    show_login_compoments: false,
    show_userinfo_compoments: false,
    show_code_exchange_compoments: false,
    show_bindphone_compoments: false,
    show_attendance_compoments: false,
    show_open_compoments: false,
    show_question_compoments: false,
    show_toast_vip: false,
    shou_invite_code: false,
    video_type: 0,
    show_kehu_tip:false,
    show_vip_time:false,
    isPayPopShow:false,
    kelingTool:'bloombloom',
    upYouDetail:{},
    fisYouh: false,//挽留1
    secYouh: false,//挽留2
    header_r_show:1,
    vip_youhui_header_show:false,//header顶部是否显示优惠提示
    vip_congratulations_show:false,//恭喜你成为xxx会员弹框

    Technical_Show: false,//技术维护弹窗
};

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {

    }
})
